import { FC } from 'react';
import { Box, Typography, Switch } from '@mui/material';
import { Preference } from '@libs/models';

interface JobseekerPreferencesProps {
  localPreferences: Partial<Preference>;
  handleToggle: (field: keyof Preference, value: boolean) => Promise<void>;
  isUpdating: boolean;
}

export const JobseekerPreferences: FC<JobseekerPreferencesProps> = () => {
  return null;

  return (
    // Placeholder for future jobseeker-specific notifications
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2.5,
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        opacity: 0.5,
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography variant="body1" fontWeight={500} sx={{ mb: 0.5 }}>
          Future Notification Type
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
          Placeholder for future jobseeker-specific notifications
        </Typography>
      </Box>
      <Switch disabled checked={false} />
    </Box>
  );
};
